export default __webpack_public_path__ + "static/campaign-21d00d1368a54861353b78ad4e776e62.mp4";